module.exports = __webpack_public_path__ + "img/6-4.93e67c51.jpg";